import AppView from './AppView';

import './app-view.css';

export default AppView;
